module.exports = __webpack_public_path__ + "static/media/Dashboard.e340d4ac.scss";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layouts/Admin/dashboard/Dashboard.scss
// module id = 1222
// module chunks = 0